import React from 'react';
import PropTypes from 'prop-types';
import {
  BlueChip,
  GreenChip,
  Input,
  Option,
  TagsContainer,
  TrainingTypeChip,
} from './DetailedRadioIconField.styled';
import { TrainingTypes } from '@config/enums/FormationTypeEnum';

const DetailedRadioIconOption = ({
  style,
  eventHandler,
  name,
  id,
  value,
  checked,
  timestamp,
  trainingType,
}) => {
  const trainingTypesEligibleCPF = [
    TrainingTypes.diplomantes,
    TrainingTypes.certifiantes,
  ];

  return (
    <Option style={style} $checked={checked}>
      <Input
        type="radio"
        name={name}
        id={id}
        value={value}
        checked={checked}
        onClick={eventHandler}
        onChange={(e) => e.preventDefault()}
      />
      {name}

      <TagsContainer>
        {trainingTypesEligibleCPF.includes(trainingType) && (
          <BlueChip>CPF</BlueChip>
        )}

        {timestamp && (
          <>
            {timestamp >= 10 && <GreenChip>9 à {timestamp} mois</GreenChip>}

            {timestamp > 5 && timestamp < 10 && (
              <GreenChip>
                {timestamp - 1} à {timestamp} mois
              </GreenChip>
            )}

            {timestamp <= 5 && (
              <GreenChip>
                1 à {timestamp - 1 === 1 ? timestamp : timestamp - 1} mois
              </GreenChip>
            )}
          </>
        )}

        {trainingType && (
          <TrainingTypeChip $trainingType={trainingType}>
            {trainingType}
          </TrainingTypeChip>
        )}
      </TagsContainer>
    </Option>
  );
};

DetailedRadioIconOption.propTypes = {
  style: PropTypes.object,
  eventHandler: PropTypes.func.isRequired,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  checked: PropTypes.bool,
  timestamp: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default DetailedRadioIconOption;
